import { httpRequest } from "@services/http";
import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";

export class CommandGetAd {
  async run(adId: number, expand?: "children" | "content") {
    let url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/${adId}`;

    if (expand) {
      url += `?expand=${expand}`;
    }

    const response = await httpRequest(url, {
      method: "GET",
    });
    return this.deserialize(response);
  }

  deserialize(data: any): Ad {
    const serializer = new AdSerializer();
    return serializer.deserialize(data);
  }
}
